import { get } from "lodash";
import i18n from "../app/i18n";

const getDefaultSpecsKey = (key: string) => {
  const keyParts = key.split(".");
  if (keyParts.length < 3 || keyParts[0] !== "specs") {
    return "";
  }

  if (keyParts[1] === "default") {
    return "";
  }

  return ["specs", "default", ...keyParts.slice(2)].join(".");
};

export const getSpecsTranslationKey = (key: string | undefined) => {
  if (!key) {
    return "";
  }

  if (i18n.exists(key)) {
    return key;
  }

  const defaultKey = getDefaultSpecsKey(key);
  if (defaultKey && i18n.exists(defaultKey)) {
    return defaultKey;
  }

  return "";
};

export const translateSpecs = (key: string | undefined, defaultValue = "") => {
  const translationKey = getSpecsTranslationKey(key);
  if (translationKey) {
    return i18n.t(translationKey);
  }

  if (key) {
    return key;
  }

  return defaultValue;
};

export const getSpecsValue = <T>(
  value: Record<string, unknown>,
  key: string | undefined
) => {
  if (!key) {
    return undefined;
  }

  const defaultKey = getDefaultSpecsKey(key);
  const resolvedKeys = defaultKey ? [key, defaultKey] : [key];
  for (const candidateKey of resolvedKeys) {
    const candidateValue = get(value, candidateKey);
    if (candidateValue !== undefined) {
      return candidateValue as T;
    }
  }

  return undefined;
};
